/* Check for document ready */
function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
      // call on next available tick
      setTimeout(fn, 1);
  } else {
      document.addEventListener("DOMContentLoaded", fn);
  }
}

docReady(function() {
  // DOM is loaded and ready for manipulation here

  const loggedInClasses = ['usertype-1', 'usertype-2', 'usertype-3'];
  if (loggedInClasses.some(className => document.body.classList.contains(className))) {
    updateTradeLink();
  }

  function updateTradeLink() {
    const firstName = document.querySelector('.header-wrapper')?.getAttribute('data-first-name');
    //console.log(firstName);
    let tradeLink = document.querySelector('.header__store-information__item span');
    let tradeLinkText = 'LOG OUT';
    let tradeLinkURL = '/account/logout';
    if (firstName) {
      tradeLinkText = 'Welcome, ' + firstName + "!";
      tradeLinkURL = '/account';
    }
    tradeLink.innerText = tradeLinkText;
    tradeLink.parentNode.href = tradeLinkURL;
  }
});